import { render, staticRenderFns } from "./FooterDateAt.vue?vue&type=template&id=4cda2e12&scoped=true"
import script from "./FooterDateAt.vue?vue&type=script&lang=js"
export * from "./FooterDateAt.vue?vue&type=script&lang=js"
import style0 from "./FooterDateAt.vue?vue&type=style&index=0&id=4cda2e12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cda2e12",
  null
  
)

export default component.exports